var map = {
	"./Common_Moorhen.mp3": "c8c4",
	"./Common_Tern.mp3": "e080",
	"./Corn_Crake.mp3": "0cdd",
	"./Eurasian_Coot.mp3": "b013",
	"./Eurasian_Wigeon.mp3": "07ce",
	"./Goosander.mp3": "6815",
	"./Great_Bittern.mp3": "9956",
	"./Green_winged_Teal.mp3": "72f6",
	"./Grey_Heron.mp3": "02e0",
	"./Kingfisher.mp3": "8904",
	"./Mallard.mp3": "2438",
	"./Mute_Swan.mp3": "5e6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16b9";